import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import Loading from "../UI/Loading";

/** Lista dos cursos da instituição. */
export default function CursoTable({ cursos, isLoading, onEdit, onDelete }) {
  if (isLoading) {
    return (
      <Box py={6}>
        <Loading description="Carregando cursos..." />
      </Box>
    );
  }

  if (cursos.length === 0) {
    return (
      <Box
        sx={{
          py: 6,
          textAlign: "center",
          color: "text.secondary",
          border: 1,
          borderStyle: "dashed",
          borderColor: "divider",
          borderRadius: 2,
        }}
      >
        <SchoolOutlinedIcon fontSize="large" />
        <Typography variant="body2" mt={1}>
          Nenhum curso cadastrado.
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}>
      <Table size="small" aria-label="Cursos">
        <TableHead>
          <TableRow sx={{ "& th": { fontWeight: 600, bgcolor: "action.hover" } }}>
            <TableCell>Descrição</TableCell>
            <TableCell sx={{ width: 140 }}>Abreviação</TableCell>
            <TableCell align="right" sx={{ width: 96 }} />
          </TableRow>
        </TableHead>
        <TableBody>
          {cursos.map((curso) => (
            <TableRow key={curso.codCurso} hover>
              <TableCell>{curso.descricao}</TableCell>
              <TableCell>
                {curso.abreviacao ? <Chip size="small" variant="outlined" label={curso.abreviacao} /> : "--"}
              </TableCell>
              <TableCell align="right">
                <Tooltip title="Editar">
                  <IconButton size="small" onClick={() => onEdit(curso)}>
                    <EditOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Remover">
                  <IconButton size="small" onClick={() => onDelete(curso)}>
                    <DeleteOutlineIcon fontSize="small" color="error" />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
